import { clsx } from 'clsx'
import { type CSSProperties, type FC } from 'react'

import { type AlgoliaRecord } from '../../../algolia'
import { SliderButton, useSliderNavigation } from '../../../slider'
import { getNonEmptyStyleStringValue } from '../../styles/getNonEmptyStyleStringValue'
import { StoryblokProductBatteryItem } from '../StoryblokProductBatteryItem'

import styles from './StoryblokProductBatterySlider.module.css'

type StoryblokProductBatterySliderProps = {
  itemsPerRow?: string
  products: AlgoliaRecord[]
}

export const StoryblokProductBatterySlider: FC<
  StoryblokProductBatterySliderProps
> = ({ itemsPerRow, products }) => {
  const { containerProps, leftRef, rightRef } =
    useSliderNavigation<HTMLUListElement>()

  return (
    <div
      className={styles.slider}
      style={
        {
          '--cms-product-battery-slider-items-per-page-desktop':
            getNonEmptyStyleStringValue(itemsPerRow),
        } as CSSProperties
      }
    >
      <ul className={styles.slider__container} {...containerProps}>
        {products.map((product) => (
          <li className={styles.slider__item} key={product.objectID}>
            <StoryblokProductBatteryItem product={product} />
          </li>
        ))}
      </ul>
      <SliderButton
        aria-label="previous"
        className={clsx(styles['slider__navigation-button'], 'left-0')}
        direction="left"
        ref={leftRef}
      />
      <SliderButton
        aria-label="next"
        className={clsx(styles['slider__navigation-button'], 'right-0')}
        direction="right"
        ref={rightRef}
      />
    </div>
  )
}
